var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-lg-12" }, [
      _c("div", { staticClass: "panel panel-bordered mb-0" }, [
        _vm._m(0),
        _c("div", { staticClass: "panel-body" }, [
          _c("form", { staticClass: "form-horizontal" }, [
            _c("div", { staticClass: "form-group row" }, [
              _c("h5", { staticClass: "col-md-12" }, [
                _vm._v("Game Instance Name"),
              ]),
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.game.name,
                        expression: "game.name",
                      },
                    ],
                    ref: "name",
                    staticClass: "form-control form__input",
                    attrs: { type: "text", autocomplete: "off" },
                    domProps: { value: _vm.game.name },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.game, "name", $event.target.value)
                        },
                        function ($event) {
                          return _vm.showValid("name")
                        },
                      ],
                    },
                  }),
                  _vm.showErrorNameValidation
                    ? _c("nameValidation", { attrs: { $v: _vm.$v } })
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "form-group row" }, [
              _c("h5", { staticClass: "col-md-12" }, [_vm._v("Game")]),
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.category,
                        expression: "category",
                      },
                    ],
                    staticClass: "form-control col-md-12",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.category = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "fortune" } }, [
                      _vm._v("Cigarette Fortune"),
                    ]),
                    _c("option", { attrs: { value: "advocacy" } }, [
                      _vm._v("Cigarette Advocacy"),
                    ]),
                    _c("option", { attrs: { value: "sustainable" } }, [
                      _vm._v("Cigarette Sustainable"),
                    ]),
                    _c("option", { attrs: { value: "space" } }, [
                      _vm._v("Cigarette Space"),
                    ]),
                    _c("option", { attrs: { value: "run" } }, [
                      _vm._v("Cigarette Run"),
                    ]),
                    _c("option", { attrs: { value: "sunset_drive" } }, [
                      _vm._v("Sunset Drive"),
                    ]),
                  ]
                ),
              ]),
            ]),
            _c("div", { staticClass: "form-group row" }, [
              _c("h5", { staticClass: "col-md-12" }, [_vm._v("User Group")]),
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectUserGroup,
                        expression: "selectUserGroup",
                      },
                    ],
                    staticClass: "form-control col-md-12",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectUserGroup = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.usergroups, function (group) {
                    return _c(
                      "option",
                      { key: group.id, domProps: { value: group.id } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(" " + group.id + " - " + group.group_code) +
                            " "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "panel-footer" }, [
          _c("div", { staticClass: "d-flex justify-content-between" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-round btn-default mx-10",
                attrs: { type: "button" },
                on: { click: _vm.close },
              },
              [
                _c("i", {
                  staticClass: "icon md-close",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" Cancel "),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-round btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.createGame },
              },
              [
                _c("i", {
                  staticClass: "icon md-check",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" Create "),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h3", { staticClass: "panel-title" }, [
        _vm._v("Create New Game Instance"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }